<template>
  <div class="TypeSwitchControl">
    <div
      class="TypeSwitchContainer"
      :class="{ enabled: getSortType }"
      @click="toggle"
    >
      <div class="TypeSwitchButton"></div>
    </div>
    <div @click="toggle" class="TypeSwitchLabel">
      <slot>Only challenges</slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TypeSelector",
  model: {
    prop: "isEnabled",
    event: "toggle",
  },
  methods: {
    ...mapActions(["updateSortType"]),
    toggle: function() {
      this.updateSortType(!this.getSortType);
    },
  },
  computed: {
    ...mapGetters(["getSortType", "getQuestions"]),
    hasChallenges() {
      return this.getQuestions?.find((q) => q.isChallenge === true);
    },
  },
};
</script>

<style lang="scss" scoped>
.TypeSwitchControl {
  display: flex;
  flex-direction: row;
  align-items: center;

  .TypeSwitchContainer {
    $switch-button-height: 1.4em;
    $switch-button-color: #4568dc;
    $switch-button-border-thickness: 1px;
    $switch-transition: all 0.3s ease-in-out;
    $switch-is-rounded: true;

    display: flex;
    align-items: center;
    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    border: $switch-button-border-thickness solid $switch-button-color;
    box-shadow: inset 0px 0px $switch-button-border-thickness 0px
      rgba(0, 0, 0, 0.33);
    border-radius: if($switch-is-rounded, $switch-button-height, 0);
    transition: $switch-transition;
    $button-side-length: calc(
      #{$switch-button-height} - (3 * #{$switch-button-border-thickness})
    );
    cursor: pointer;

    .TypeSwitchButton {
      height: 1.2em;
      width: $button-side-length;
      border: $switch-button-border-thickness solid white;
      border-radius: if($switch-is-rounded, $button-side-length, 0);
      background: $switch-button-color;
      transition: $switch-transition;
      transform: translateX(2px);
    }

    &.enabled {
      background-color: $switch-button-color;
      box-shadow: none;
      .TypeSwitchButton {
        background: white;
        border: $switch-button-border-thickness solid $switch-button-color;
        transform: translateX(
          calc(#{$button-side-length} + (3 *#{$switch-button-border-thickness}))
        );
      }
    }
  }
  .TypeSwitchLabel {
    cursor: pointer;
    margin-left: 10px;
  }
}
</style>
